<template>
  <div v-if="faturamentoLotes.length === 0">
    Nenhum lote de faturamento encontrado.
  </div>
  <v-list v-else flat>
    <v-list-item
      v-for="faturamentoLote in faturamentoLotes"
      :key="faturamentoLote.id"
      class="px-0"
    >
      <v-list-item-content class="pt-0">
        <pagamento-baixa-faturamento-lote-card
          v-on="$listeners"
          :isSelected="isSelected(faturamentoLote.id)"
          :isAssociado="faturamentoLoteIdsAssociados.has(faturamentoLote.id)"
          :faturamentoLote="faturamentoLote"
        />
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import PagamentoBaixaFaturamentoLoteCard from './PagamentoBaixaFaturamentoLoteCard.vue'

export default {
  components: {
    PagamentoBaixaFaturamentoLoteCard
  },
  props: {
    faturamentoLotes: Array,
    selectedFaturamentoLotes: Array,
    conciliacaoLotes: Array
  },
  computed: {
    faturamentoLoteIdsAssociados () {
      return new Map(
        this.conciliacaoLotes.map(conciliacaoLote => [
          conciliacaoLote.faturamentoLoteId,
          conciliacaoLote.id
        ])
      )
    }
  },
  methods: {
    isSelected (faturamentoLoteId) {
      return this.selectedFaturamentoLotes.some(lote => lote.id === faturamentoLoteId)
    }
  }
}
</script>
